import React, { useState } from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import Dialog from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Dialog';
import FeedbackAdditionalDetailsContent
  from 'Components/ComponentLibrary/Organisms/UserFeedback/UserFeedbackPicker/UserFeedbackQuestion/FeedbackAdditionalDetailsModal/FeedbackAdditionalDetailsContent';
import FeedbackAdditionalDetailsCompletedContent
  from 'Components/ComponentLibrary/Organisms/UserFeedback/UserFeedbackPicker/UserFeedbackQuestion/FeedbackAdditionalDetailsModal/FeedbackAdditionalDetailsCompletedContent';
import useMobileLayout from 'Hooks/useMobileLayout';


const useStyles = buildUseStyles('FeedbackAdditionalDetailsModal', (() => ({
  root: { },
})));

const steps = {
  ADDITIONAL_DETAILS: 'ADDITIONAL_DETAILS',
  COMPLETED: 'COMPLETED',
};

const FeedbackAdditionalDetailsModal = ({ resource, onClose }) => {
  const classes = useStyles();
  const [step, setStep] = useState(steps.ADDITIONAL_DETAILS);
  const isMobile = useMobileLayout();

  const onSubmit = () => {
    setStep(steps.COMPLETED);
  };

  const getStepContent = () => {
    switch (step) {
      case steps.ADDITIONAL_DETAILS:
        return (
          <FeedbackAdditionalDetailsContent
            resource={resource}
            onSubmit={onSubmit}
          />
        );
      case steps.COMPLETED:
        return (
          <FeedbackAdditionalDetailsCompletedContent
            onClose={onClose}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Dialog
      className={classes.root}
      fullScreen={isMobile}
      onClose={() => onClose()}
      showCloseIcon={step === steps.ADDITIONAL_DETAILS}
      open
    >
      {getStepContent()}
    </Dialog>
  );
};

FeedbackAdditionalDetailsModal.defaultProps = {
  onClose: () => {},
};

FeedbackAdditionalDetailsModal.propTypes = {
  resource: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

export default FeedbackAdditionalDetailsModal;
